import React, { useState, useMemo } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import DatesFilter from '../filters/DatesFilter';
import { formatMinWordDate } from '../../helpers';
import dayjs from '../../config/dayjs';

const DateRangePickerButton = ({ dates, setDates, disabled = false }) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);

  const normalizeDates = useMemo(() => {
    if (dates.startDate && dates.endDate) {
      return {
        dateIssued_Gte: dates.startDate,
        dateIssued_Lte: dates.endDate,
      };
    }
    return dates;
  }, [dates]);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <Button
        disableRipple
        variant="outlined"
        onClick={handleOpen}
        id="filter-dates"
        disabled={disabled}
        endIcon={<CalendarTodayIcon />}
        sx={{
          width: '10rem',
          cursor: 'pointer',
          color: theme.palette.gray.A500,
          borderColor: theme.palette.gray.A500,
          '&:hover': {
            borderColor: theme.palette.gray.A500,
            backgroundColor: theme.palette.gray.A100,
          },
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          gap={1}
          sx={{ cursor: 'pointer' }}
        >
          <Typography variant="small_2" fontWeight={500} color={theme.palette.gray.A500}>
            {`${formatMinWordDate(normalizeDates.dateIssued_Gte)} - ${formatMinWordDate(normalizeDates.dateIssued_Lte)}`}
          </Typography>
        </Box>
      </Button>
      <DatesFilter
        anchorEl={anchorEl}
        close={handleClose}
        dates={normalizeDates}
        setDates={setDates}
      />
    </Box>
  );
};

DateRangePickerButton.propTypes = {
  dates: PropTypes.shape({
    startDate: PropTypes.instanceOf(dayjs),
    endDate: PropTypes.instanceOf(dayjs),
  }).isRequired,
  setDates: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
DateRangePickerButton.defaultProps = {
  disabled: false,
};

export default DateRangePickerButton;
